<template>
  <v-card class="align-center">   
    <v-card-title primary-title>
      <div class="text-h4">
        Fakturor
      </div>
      <v-spacer />                     
      <v-card v-if="guarantee !== null && guarantee.length > 0" class="d-flex justify-left w-33">          
        <v-card-title class="text-h5">
          Garantibelopp
        </v-card-title>
        <v-simple-table dense>
          <thead>
            <tr>
              <th>Belopp</th>
              <th>Tidning</th>
              <th>Återbetald</th>
              <th>Datum </th>              
            </tr>
          </thead>
          <tbody>
            <tr v-for="(paper, pIndex) in guarantee[0].paperGuaranteeAmount" :key="pIndex">
              <td>{{ paper.amount|toCurrency }}</td>
              <td>{{ paper.ledger|ledgerToString }}</td>
              <td>{{ paper.refunded ? 'Ja' : 'Nej' }}</td>
              <td>{{ paper.refundedDate|toLocalDate }}</td>            
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-card-title> 
    
      
    <v-container v-if="loading">
      <v-overlay>
        <v-row class="fill-height"
               align-content="center"
               justify="center"
        >
          <v-col
            class="text-subtitle-1 text-center"
            cols="12"
          >
            Hämtar data...
          </v-col>
          <v-col cols="12">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
            />
          </v-col>
        </v-row>        
      </v-overlay>
    </v-container>                     
 
    <v-container v-else-if="!loading && invoiceList[0].invoices.length > 0 || invoiceList[1].invoices.length > 0">                                    
      <v-container v-for="(invoiceProvider,idx) in invoiceList" :key="idx">                     
        <div class="text-h5">
          {{ invoiceProvider.paper }}        
        </div>
        <v-row v-if="$vuetify.breakpoint.mdAndUp" dense class="ma-1 text-h6 font-weight-light text-uppercase"> 
          <v-col cols="2">
            Nummer
          </v-col>
          <v-col cols="2">
            Datum
          </v-col>
          <v-col cols="2">
            Förfallodatum
          </v-col>          
          <v-col cols="2">  
            Summa
          </v-col>
          <v-col cols="2">  
            Status
          </v-col>                    
          <v-col cols="1">
            Faktura
          </v-col>
        </v-row>     
        <div v-for="invoice in invoiceProvider.invoices" :key="invoice.number">
          <Invoice :invoice="invoice" :paper="invoiceProvider.paper" />   
        </div>
      </v-container>    
    </v-container>  
    <v-container v-else-if="!loading && invoiceList[0].invoices.length === 0 && invoiceList[1].invoices.length === 0">
      <h3>Hittar inga fakturor</h3>
    </v-container>   
  </v-card>
</template>

<script>
import log from '@/logger'
import api from '@/backend/api'
import Invoice from '@/components/web/Invoice'

export default {
  name:'InvoiceList',
  components:{Invoice},
  data(){
    return {
      invoices:[],
      loading:true,
      guarantee:null
    }
  },
  computed:{
    invoiceList(){
      return this.invoices
    }
  },
  mounted(){
     api.getInvoices(0).then(resp => {     
       log.debug('Got invoices for Aftonbladet', resp.data)  
          this.invoices.splice(0,0,resp.data)
          api.getInvoices(1).then(resp => {     
            log.debug('Got invoices for Expressen', resp.data)  
            this.invoices.splice(1,0,resp.data)
            this.loading = false
            })   
        })   
    api.getGuarantee().then(resp => {
      log.debug('Got guarantee', resp.data)
      this.guarantee = resp.data.result
    }).catch(err => {
      log.error('Error getting guarantee', err)
    })    
    
  }
}
</script>